const warnFullStoryDeprecation = () => {
  // eslint-disable-next-line no-console
  console.warn('Deprecation Notice: FullStory Usage is deprecated and removed from SHELL.');
  return 'fullstory url not available';
};

function useFullstoryHelpers() {
  return {
    getCurrentUrl: warnFullStoryDeprecation,
    getCurrenyUrl: warnFullStoryDeprecation,
  };
}

export default useFullstoryHelpers;
